// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2WkqkA5sPUgbwS7hSBCU-p","footerbuttons":"YpgGAhtNk2Prl8p1YeZ7G"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/MessageBox/FooterLayout.scss
// module id = ./node_modules/wix-style-react/dist/es/src/MessageBox/FooterLayout.scss
// module chunks = 0